'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z' });

var Subject = function Subject(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Subject = (0, _pure2.default)(Subject);
Subject.muiName = 'SvgIcon';

exports.default = Subject;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Subject.js
// module id = 2904
// module chunks = 0